<div class="d-flex align-items-center">
    <div class="logo">
        <img src="assets/logo.svg" alt="Logo" />
    </div>
    <div>
        <p class="application-name">
            {{
            'COMMON.CONCIERGE_CARE' | translate
            }}
        </p>
        <p class="application-secondary-name">
            {{
            'COMMON.SENIOR_NAVIGATOR' | translate
            }}
        </p>
    </div>
</div>